module.exports = __webpack_public_path__ + "img/ef9a020b84f949b3b8418f0d94d49fa1.ef9a020b.png";